import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen bg-slate-950 text-white px-4 py-12">
      <div className="max-w-3xl mx-auto space-y-4">
        <h1 className="text-3xl font-bold text-purple-100">About</h1>
        <p className="text-purple-200">
          We are building focused dashboards that surface insights for modern delivery teams. This page will soon include a story
          about our vision, architecture choices, and roadmap.
        </p>
      </div>
    </div>
  );
};

export default About;
